import React, {useEffect, useState} from 'react';
import DashPlatform from "./DashPlatform";
import DashFclty from "./DashFclty";
import {getUserInfo} from "../api/apiClient";
import useAuth from "../hook/useAuth";

const DashAuthSelect = () => {

  const [ogdpInfo, setOgdpInfo] = useState('admin');
  const [ogdpDetailInfo, setOgdpDetailInfo] = useState('');

  useEffect(() => {
    // API 호출
    const userId = sessionStorage.getItem('LOGIN_NAME')
    getUserInfo(userId).then(res => {
      const ogdpTy = res.data.data.ogdp_ty;
      const ogdpTyDetail = res.data.data.ogdp_ty_detail
      if (ogdpTy == 4) {
        setOgdpInfo('admin');
      } else if (ogdpTy == 3) {
        setOgdpInfo('자치구');
        setOgdpDetailInfo(ogdpTyDetail)
      } else if (ogdpTy == 1) {
        setOgdpInfo('시설관리자');
        setOgdpDetailInfo(res.data.data.ogdp_ty_detail_cd)
      }
      console.log(res);
    })
  }, []);

  const auth = useAuth();
  // console.log(auth);

  return (
      <>
        {ogdpInfo === "admin" ? (
            <DashPlatform
                propAuthInfo={0}
                propAuth={auth}
            />
        ) : <></>}
        {ogdpInfo === "자치구" ? (
            <DashPlatform
                propAuthInfo={ogdpDetailInfo}
                propAuth={auth}
            />
        ) : <></>}
        {ogdpInfo === "시설관리자" ? (
            <DashFclty
                propAuthInfo={ogdpDetailInfo}
                propAuth={auth}
            />
        ) : <></>}
      </>
  );
};

export default DashAuthSelect;
